export const inputTypes = ['text', 'email', 'password', 'number'] as const
